module.exports = __webpack_public_path__ + "static/church-5f73b69faee0226f0a53ff33583ed1d2.jpg";